import { Controller } from "@hotwired/stimulus"

// 面談URLなどのコピー用
export default class extends Controller {
  static targets = ["source", "label"]

  async copy() {
    await navigator.clipboard.writeText(this.sourceTarget.textContent.trim())
    if (this.hasLabelTarget) {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = "コピーしました"
      setTimeout(() => { this.labelTarget.textContent = original }, 1500)
    }
  }
}
